"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentation = void 0;
class ExperimentationWeb {
    getBooleanFeatureGate(featureName, defaultValue) {
        try {
            let featureGateValue = Microsoft.Office.WebExtension.FeatureGates[featureName];
            return (featureGateValue === undefined || featureGateValue === null) ? defaultValue :
                featureGateValue.toString().toLowerCase() === 'true';
        }
        catch (error) {
            return defaultValue;
        }
    }
    getIntFeatureGate(featureName, defaultValue) {
        try {
            let featureGateValue = parseInt(Microsoft.Office.WebExtension.FeatureGates[featureName]);
            return isNaN(featureGateValue) ? defaultValue : featureGateValue;
        }
        catch (error) {
            return defaultValue;
        }
    }
    getStringFeatureGate(featureName, defaultValue) {
        try {
            let featureGateValue = Microsoft.Office.WebExtension.FeatureGates[featureName];
            return (featureGateValue === undefined || featureGateValue === null) ? defaultValue : featureGateValue;
        }
        catch (error) {
            return defaultValue;
        }
    }
    getChangeGate(changeGateName) {
        return this.getBooleanFeatureGate(changeGateName, true /*defaultValue*/);
    }
    getBooleanFeatureGateAsync(featureName, defaultValue) {
        return Promise.resolve(this.getBooleanFeatureGate(featureName, defaultValue));
    }
    getIntFeatureGateAsync(featureName, defaultValue) {
        return Promise.resolve(this.getIntFeatureGate(featureName, defaultValue));
    }
    getStringFeatureGateAsync(featureName, defaultValue) {
        return Promise.resolve(this.getStringFeatureGate(featureName, defaultValue));
    }
}
exports.experimentation = new ExperimentationWeb();
//# sourceMappingURL=experimentation-web.js.map